<template>
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width="16"
        height="16"
        fill="none"
        viewBox="0 0 16 16"
        :aria-labelledby="props.ariaLabelledby"
        :aria-hidden="!props.ariaLabelledby"
        role="img"
    >
        <path fill="currentColor" d="M6 12V4l4 4-4 4Z" />
    </svg>
</template>

<script setup lang="ts">
type TriangleIconProps = {
    ariaLabelledby?: string;
};

const props = defineProps<TriangleIconProps>();
</script>
